import React ,{useState , useEffect}from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/SearchResults/Hero/Hero";
import Cards from "../../components/SearchResults/cards/Cards";
import UpButton from '../../components/UpButton';
import { useSearchParams , useNavigate , Link} from "react-router-dom";
//============================================
import styles from "./SearchResults.module.scss";
import { Helmet } from "react-helmet";
import { products } from '../../Data/ProductsDetails';
import {searchFunctionality} from '../../Utility/searchFunctionality' ;

const SearchResults = ({scroll}) => {
  const [SearchParams]=useSearchParams() ;
  let src = SearchParams.get('src') ;
  const navigate = useNavigate();
  const [requestedPro, setRequestedPro] = useState([]);
  useEffect(() => {
    if(src === ''||src ===null){
        navigate("/",{replace :true});
        return ;
    }else{
      const arr = searchFunctionality(products,src);
      const filtered = [...new Set(arr)]
      setRequestedPro(filtered);
    }
  },[src,navigate])
  return (
    <div>
      <Helmet>
        <title>Millensys - Search</title>
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        <Header />
        <Hero />
              <div className={styles["certification_container"]}>
                <div className={styles["section__container"]}>
                  <p className={styles["section__subheader"]}>Search Results...</p>
                  { (requestedPro.length === 0) ?
                    <>
                      <p className={styles["__strong"]}>
                        Your kind feedback is going to be highly appreciated, You might be interested in our following recommendations
                      </p>
                      <button className={styles["product___btn"]} >
                        <Link to={`/products`}>Learn More</Link>
                      </button>
                    </> :
                    <p className={styles["__strong"]}>Your kind feedback is going to be highly appreciated </p>
                  }
                </div>
              </div>
              <Cards  data={requestedPro} src={src}/>
        <Footer />
      </div>
    </div>
  );
};

export default SearchResults;
